import { Guid } from "guid-typescript";
import Utility from "../../foundation/Utility";
import DistributionTypes from "../../types/enums/DistributionTypes";
import MessageAttachment from "../../types/system/MessageAttachment";
import MessageRecipient from "../../types/system/MessageRecipient";
import RecipientTypes from "../enums/RecipientTypes";
import Message from "./Message";

export default class MessagingMessage {
    Sender: number;
    SchoolID: number;
    ClientSystemID: number;
    Title: string;
    Content: string;
    Distribution: Array<DistributionTypes>;
    CustomDistribution: Record<DistributionTypes, number>;
    Recipients: MessageRecipient[];
    Attachments: MessageAttachment[];

    constructor(
        sender: number,
        schoolID: number,
        applicationID: number,
        title: string,
        content: string,
    ) {
        this.Sender = sender;
        this.SchoolID = schoolID;
        this.ClientSystemID = applicationID;
        this.Title = title;
        this.Content = content;

        this.Distribution = new Array<DistributionTypes>();
        this.CustomDistribution = {} as Record<DistributionTypes, number>;
        this.Recipients = new Array<MessageRecipient>();
        this.Attachments = new Array<MessageAttachment>();
    }

    setDistribution(type: DistributionTypes) {
        this.Distribution.push(type);
    }

    setCustomDistribution(type: DistributionTypes, value: number) {
        this.CustomDistribution[type] = value;
    }

    addRecipient(type: RecipientTypes, id: number) {
        this.Recipients.push({
            recipientType: type,
            recipientId: id,
            customTarget: undefined,
            attachments: [],
        });
    }

    addCustomRecipient(type: RecipientTypes, target: string, id: number) {
        this.Recipients.push({
            recipientType: type,
            recipientId: id,
            customTarget: target,
            attachments: [],
        });
    }

    async addAttachment(file: File) {
        const buffer = await Utility.fileToBase64(file);

        this.Attachments.push({
            title: file.name,
            mime: file.type,
            content: buffer,
        });
    }

    async addAttachments(files: Array<File>) {
        for (const file of files) await this.addAttachment(file);
    }

    toMessage(): Message {
        return new Message({
            id: Guid.create().toString(),
            schoolId: this.SchoolID,
            sender: this.Sender,
            clientSystemId: this.ClientSystemID,
            title: this.Title,
            content: this.Content,
            distribution: this.Distribution,
            customDistribution: this.CustomDistribution,
            distributionStatus: {} as Record<DistributionTypes, boolean>,
            recipients: this.Recipients,
            attachments: this.Attachments,
        });
    }
}
